// extracted by mini-css-extract-plugin
export var alertIcon = "_nq-0";